import React, { FC, useContext } from 'react';
import { PopupHeaderProps } from './popupHeader.types';
import { StyledPopupHeaderDiv } from './popupHeader.styles';
import { ContentContext, ViewportContext } from '../../index.contexts';

const PopupHeader: FC<PopupHeaderProps> = ({
  className,
  children,
  cancelLabel,
  cancelClickHandler,
  mainText,
  labelText,
  labelIcon,
  inputId,
  labelledById,
  removeScreenReaderClass = false,
}) => {
  const isMobileView = useContext(ViewportContext);
  const LabelTag = inputId ? 'label' : 'span';
  const { placeholderTextMobile, placeholderTextDesktop, currentLocationText } = useContext(ContentContext);

  // click anywhere on the wrapper will move focus to input
  const withInputClickHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    // if click happened on the element itself not its children
    if (e.target === e.currentTarget && inputId) {
      const inputElement: HTMLElement | null = document.getElementById(inputId);
      inputElement?.focus();
    }
  };
  return (
    <StyledPopupHeaderDiv data-component-name="a-shop-PopupHeader" data-testid="shop-PopupHeader" className={className}>
      {!isMobileView && inputId ? (
        <div className="with-input hover-60" onClick={withInputClickHandler} id={labelledById ?? ''}>
          <div className="dashed-border">
            <label
              htmlFor={inputId}
              id={`${inputId}-label`}
              className={`${labelIcon} icon-s icon-decorative search__destination-label`}
            >
              <span className="t-label-xs">{labelText}</span>
              {!removeScreenReaderClass && (
                <span className="sr-only">
                  {placeholderTextDesktop as string}
                  {currentLocationText}
                </span>
              )}
            </label>
            {children}
          </div>
        </div>
      ) : (
        <>
          {/* id is needed to be consumed by the <ul> element of autocomplete options for aria-labelledby attribute */}
          <LabelTag
            htmlFor={inputId}
            className={`${labelIcon !== undefined ? labelIcon : ''} ${
              isMobileView ? 't-label-inverse-xs custom-label' : 't-label-xs custom-label'
            }`}
            id={inputId ? `${inputId}-label` : ''}
          >
            {labelText}
            {!removeScreenReaderClass && (
              <span className="sr-only">
                {placeholderTextMobile as string}
                {currentLocationText}
              </span>
            )}
          </LabelTag>
          <div className={`${labelIcon ? 'icon-with-label' : 'label-text'}`}>
            {children ?? (
              <div className={`${labelIcon ? 't-title-inverse-s' : 't-subtitle-inverse-l'}`}>{mainText}</div>
            )}
            {cancelClickHandler ? (
              <button className="link-white" onClick={cancelClickHandler}>
                {cancelLabel}
              </button>
            ) : (
              ''
            )}
          </div>
        </>
      )}
    </StyledPopupHeaderDiv>
  );
};

export default PopupHeader;
